<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.quote.selected_quote' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
<ul role="list" class="divide-y divide-gray-200 overflow-y-auto zuper-scrollbar data-picker-list-content-height"
    *ngIf="quotes.length">
    <li class="quote-data-picker-list-ele" *ngFor="let quote of quotes">
        <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5"
            [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
            (click)="selectOption === 'readOnly' ? viewQuoteDetails($event, quote.estimate_uid) : null">
            <a class="-m-1 block flex-1 p-1">
                <div class="relative flex min-w-0 flex-1 items-center">
                    <mat-checkbox (change)="selectQuote($event, quote)" [checked]="isSelectedQuote(quote)"
                        *ngIf="selectOption === 'multiSelect'" color="primary" disableRipple="true">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="quotesContent"></ng-container>
                        </div>
                    </mat-checkbox>
                    <mat-radio-button (change)="selectQuote($event, quote)" [checked]="isSelectedQuote(quote)"
                        *ngIf="selectOption === 'select'" color="primary" disableRipple="true">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="quotesContent"></ng-container>
                        </div>
                    </mat-radio-button>
                    <ng-container *ngIf="selectOption === 'readOnly'">
                        <div class="truncate w-full">
                            <ng-container *ngTemplateOutlet="quotesContent"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #quotesContent>
                        <div class="flex items-center justify-between">
                            <div>
                                <div class="flex flex-row space-x-2">
                                    <p class="truncate flex item-center text-lg font-medium text-gray-900 cursor-pointer">
                                        {{quote?.prefix ?? ''}}{{quote?.estimate_no ?? ''}} {{quote?.proposal_title ? ' - ' + quote.proposal_title :''}}
                                        <span class="flex ml-2" *ngIf="quote?.is_proposal">
                                            <img loading="lazy" src="assets/images/svgs/clip_path_group.svg"alt="Clip Path"> 
                                        </span>
                                    </p>
                                </div>
                                <div class="flex flex-row space-x-2 mt-1" *ngIf="utilityService.hasPermission('product.show_selling_price') && !utilityService.isEmptyOrUndefined(quote?.total)">
                                    <p class="truncate text-base text-gray-500">
                                        {{currency + ' ' + (quote?.total | number:digitsInfo)}}
                                    </p>
                                </div>
                            </div>
                            <div class="ml-auto mr-4">
                                <badge *ngIf="quote?.estimate_status"
                                    [options]="getStatusBadgeOptions(quote?.estimate_status)"></badge>
                            </div>
                        </div>
                    </ng-template>
                    <button mat-icon-button class="cursor-pointer ml-auto"
                        matTooltip="{{ updateArrowTooltipText(quote.estimate_uid) | translate }}"
                        matTooltipPosition="above" *ngIf="!showSpinLoading(quote.estimate_uid)"
                        [ngClass]="rotateArrowIcon(quote.estimate_uid)"
                        (click)="viewQuoteDetails($event, quote.estimate_uid)">
                        <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                            data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down"
                                width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
                                fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                </path>
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </mat-icon>
                    </button>
                    <div class="ml-auto py-2.5 h-10" *ngIf="showSpinLoading(quote.estimate_uid)">
                        <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px">
                        </mat-spinner>
                    </div>
                </div>
            </a>
        </div>
        <div class="p-4 bg-gray-100"
                *ngIf="('quote_details_' + quote.estimate_uid === quoteEleId) && quoteDetails && !isSpinLoading">
                <div class="bg-card rounded relative">
                    <a target="_blank" class="hidden" #viewFullDetails
                        href="{{viewQuoteFullDetails(quote.estimate_uid)}}"></a>
                    <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="viewFullDetails.click($event)"
                        matTooltip="{{'text.view_details.new_tab' | translate}}" matTooltipPosition="left">
                        <button mat-icon-button>
                            <mat-icon class="text-xl">open_in_new</mat-icon>
                        </button>
                    </span>
                    <div class="text-base">
                        <div class="px-2 truncate grid grid-cols-2">
                            <div *ngIf="quoteDetails.customer?.customer_first_name"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'customer' | translate}}</p>
                                <p class="mt-1 text-gray-900"
                                    *ngIf="quoteDetails.customer?.is_deleted === true || !utilityService.hasModuleAccess('CUSTOMER')">
                                    {{quoteDetails.customer.customer_first_name}}
                                    {{quoteDetails.customer.customer_last_name ?? ''}}</p>
                                <p class="mt-1">
                                    <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                        [routerLink]="utilityService.getLink('CUSTOMER', quoteDetails.customer.customer_uid)"
                                        *ngIf="!quoteDetails.customer?.is_deleted && utilityService.hasModuleAccess('CUSTOMER')">
                                        {{quoteDetails.customer.customer_first_name}}
                                        {{quoteDetails.customer.customer_last_name ?? ''}}</a>
                                </p>
                            </div>
                            <div *ngIf="quoteDetails.organization"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'text.organization_name' | translate}}</p>
                                <p class="mt-1 text-gray-900"
                                    *ngIf="quoteDetails.organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                                    {{quoteDetails.organization?.organization_name}}</p>
                                <p class="mt-1">
                                    <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                        [routerLink]="utilityService.getLink('ORGANIZATION', quoteDetails.organization.organization_uid)"
                                        *ngIf="!quoteDetails.organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                                        {{quoteDetails.organization?.organization_name}}</a>
                                </p>
                            </div>
                            <div *ngIf="quoteDetails.property"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'text.property' | translate}}</p>
                                <p class="mt-1 text-gray-900"
                                    *ngIf="quoteDetails.property?.is_deleted === true || !utilityService.hasModuleAccess('PROPERTY')">
                                    {{quoteDetails.property?.property_name}}</p>
                                <p class="mt-1">
                                    <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                        [routerLink]="utilityService.getLink('PROPERTY', quoteDetails.property.property_uid)"
                                        *ngIf="!quoteDetails.property?.is_deleted && utilityService.hasModuleAccess('PROPERTY')">
                                        {{quoteDetails.property?.property_name}}</a>
                                </p>
                            </div>
                            <div *ngIf="quoteDetails.job"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'job' | translate}}</p>
                                <p class="mt-1 text-gray-900"
                                    *ngIf="quoteDetails.job?.is_deleted === true || !utilityService.hasModuleAccess('JOB')">
                                    {{quoteDetails?.job.prefix ?? ''}}{{quoteDetails?.job.work_order_number ?? ''}} -
                                    {{quoteDetails?.job.job_title}}</p>
                                <p class="mt-1">
                                    <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                        [routerLink]="utilityService.getLink('JOB', quoteDetails.job.job_uid)"
                                        *ngIf="!quoteDetails.job?.is_deleted && utilityService.hasModuleAccess('JOB')">
                                        {{quoteDetails?.job.prefix ?? ''}}{{quoteDetails?.job.work_order_number ?? ''}} -
                                        {{quoteDetails?.job.job_title}}</a>
                                </p>
                            </div>
                            <div *ngIf="quoteDetails.estimate_date"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'text.quote_date' | translate}}</p>
                                <p class="mt-1 text-gray-900">
                                    {{quoteDetails.estimate_date | dateformat}}</p>
                            </div>
                            <div *ngIf="quoteDetails.expiry_date"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'expiry_date' | translate}}</p>
                                <p class="mt-1 text-gray-900">
                                    {{quoteDetails.expiry_date | dateformat}}</p>
                            </div>
                            <div *ngIf="quoteDetails.created_at"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'created.at.text' | translate}}</p>
                                <p class="mt-1 text-gray-900">
                                    {{quoteDetails.created_at | datetime}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="px-2 py-2 border-t text-base"
                        *ngIf="quoteDetails.customer_service_address && (quoteDetails.customer_service_address.street || quoteDetails.customer_service_address.state)">
                        <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                            {{'text.service_address' | translate}} </p>
                        <div class="px-3">
                            <p *ngIf="quoteDetails.customer_service_address.first_name" class="text-base mb-2">
                                {{quoteDetails.customer_service_address.first_name}}
                                {{quoteDetails.customer_service_address.last_name}}</p>
                            <p *ngIf="quoteDetails.customer_service_address.street" class="text-base mb-2">
                                {{quoteDetails.customer_service_address.street}}</p>
                            <p *ngIf="quoteDetails.customer_service_address.landmark" class="text-base mb-2">
                                {{quoteDetails.customer_service_address.landmark}}</p>
                            <p *ngIf="quoteDetails.customer_service_address.city" class="text-base mb-2">
                                {{quoteDetails.customer_service_address.city}}</p>
                            <p *ngIf="quoteDetails.customer_service_address.state" class="text-base mb-2">
                                {{quoteDetails.customer_service_address.state}}
                                {{quoteDetails.customer_service_address.zip_code ? '- ' +
                                quoteDetails.customer_service_address.zip_code : '' }}</p>
                            <p *ngIf="quoteDetails.customer_service_address.country" class="text-base">
                                {{quoteDetails.customer_service_address.country}}</p>
                        </div>
                    </div>
                    <div class="px-2 py-2 border-t text-base"
                        *ngIf="quoteDetails.customer_billing_address && (quoteDetails.customer_billing_address.street || quoteDetails.customer_billing_address.state)">
                        <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                            {{'billing.address.text' | translate}} </p>
                        <div class="px-3">
                            <p *ngIf="quoteDetails.customer_billing_address.first_name" class="text-base mb-2">
                                {{quoteDetails.customer_billing_address.first_name}}
                                {{quoteDetails.customer_billing_address.last_name}}</p>
                            <p *ngIf="quoteDetails.customer_billing_address.street" class="text-base mb-2">
                                {{quoteDetails.customer_billing_address.street}}</p>
                            <p *ngIf="quoteDetails.customer_billing_address.landmark" class="text-base mb-2">
                                {{quoteDetails.customer_billing_address.landmark}}</p>
                            <p *ngIf="quoteDetails.customer_billing_address.city" class="text-base mb-2">
                                {{quoteDetails.customer_billing_address.city}}</p>
                            <p *ngIf="quoteDetails.customer_billing_address.state" class="text-base mb-2">
                                {{quoteDetails.customer_billing_address.state}}
                                {{quoteDetails.customer_billing_address.zip_code ? '- ' +
                                quoteDetails.customer_billing_address.zip_code : '' }}</p>
                            <p *ngIf="quoteDetails.customer_billing_address.country" class="text-base">
                                {{quoteDetails.customer_billing_address.country}}</p>
                        </div>
                    </div>
                </div>
            </div>
    </li>
</ul>
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!quotes.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_contracts_or_quote_found.svg" alt="No Quotes Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.quote.not_found' | translate}}
            '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.quote.placeholder' | translate}}
        </h4>
    </div>
</div>